export var IProduct;
(function (IProduct) {
    let NonReturnableReason;
    (function (NonReturnableReason) {
        /**
         * @deprecated
         */
        NonReturnableReason["FOOD"] = "FOOD";
        NonReturnableReason["HOLIDAY"] = "HOLIDAY";
        /**
         * @deprecated
         */
        NonReturnableReason["MIX_AND_MATCH"] = "MIX_AND_MATCH";
        NonReturnableReason["OVER_RETAIL_PRICE_LIMIT"] = "OVER_RETAIL_PRICE_LIMIT";
        NonReturnableReason["FACE_MASK"] = "FACE_MASK";
        /**
         * @deprecated
         */
        NonReturnableReason["IS_SAMPLE"] = "IS_SAMPLE";
        /**
         * used as a default for order items with no product based non-returnable reason
         */
        NonReturnableReason["UNKNOWN"] = "UNKNOWN";
        NonReturnableReason["NOT_RETURNABLE_FOR_BRAND"] = "NOT_RETURNABLE_FOR_BRAND";
        NonReturnableReason["DISPLAY_PRODUCT"] = "DISPLAY_PRODUCT";
    })(NonReturnableReason = IProduct.NonReturnableReason || (IProduct.NonReturnableReason = {}));
    let INonReturnableReasonData;
    (function (INonReturnableReasonData) {
        /**
         * Return an instance of INonReturnableReasonData with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        INonReturnableReasonData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(INonReturnableReasonData = IProduct.INonReturnableReasonData || (IProduct.INonReturnableReasonData = {}));
    let NonResellableReason;
    (function (NonResellableReason) {
        NonResellableReason["FOOD_DRINK"] = "FOOD_DRINK";
    })(NonResellableReason = IProduct.NonResellableReason || (IProduct.NonResellableReason = {}));
    let RelationshipType;
    (function (RelationshipType) {
        /**
         * source is what the sample is of
         */
        RelationshipType["SAMPLE"] = "SAMPLE";
    })(RelationshipType = IProduct.RelationshipType || (IProduct.RelationshipType = {}));
    /**
     * Sale States for Products and Options
     */
    let State;
    (function (State) {
        /**
         * Is the product deleted
         * Replaced with LifecycleState.SOFT_DELETED
         * @deprecated
         */
        State["DELETED"] = "DELETED";
        /**
         * Is the product intended to be sold on Faire
         */
        State["FOR_SALE"] = "FOR_SALE";
        /**
         * Is the product intended to be sold on Faire, but unable to be for some reason.
         * Eg: Out of stock, on Backorder
         */
        State["SALES_PAUSED"] = "SALES_PAUSED";
        /**
         * Is the Product not able to be sold on Faire for some reason.
         * Example reasons:
         *  - the Product is in LifecycleState.UNPUBLISHED or LifecycleState.DRAFT
         *  - the Product has pricing violations and is not sellable
         */
        State["NOT_FOR_SALE"] = "NOT_FOR_SALE";
    })(State = IProduct.State || (IProduct.State = {}));
    let LifecycleState;
    (function (LifecycleState) {
        /**
         * Draft products are only visible to brands, and are not validated
         */
        LifecycleState["DRAFT"] = "DRAFT";
        /**
         * Published products are visible to everyone
         */
        LifecycleState["PUBLISHED"] = "PUBLISHED";
        /**
         * Unpublished products are only visible to brands
         */
        LifecycleState["UNPUBLISHED"] = "UNPUBLISHED";
        /**
         * Soft deleted products are only visible to brands via special checks
         */
        LifecycleState["SOFT_DELETED"] = "SOFT_DELETED";
    })(LifecycleState = IProduct.LifecycleState || (IProduct.LifecycleState = {}));
    /**
     * Shown only to brands, represents inventory state of a product or product option
     */
    let BrandAvailability;
    (function (BrandAvailability) {
        BrandAvailability["BRAND_AVAILABILITY_UNKNOWN"] = "BRAND_AVAILABILITY_UNKNOWN";
        BrandAvailability["IN_STOCK"] = "IN_STOCK";
        BrandAvailability["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    })(BrandAvailability = IProduct.BrandAvailability || (IProduct.BrandAvailability = {}));
    let ProductOffering;
    (function (ProductOffering) {
        /**
         * Normal products are visible in search and in recommendations
         */
        ProductOffering["NORMAL_PRODUCT"] = "NORMAL_PRODUCT";
        /**
         * Sample products are no longer being used
         * @deprecated
         */
        ProductOffering["SAMPLE_PRODUCT"] = "SAMPLE_PRODUCT";
    })(ProductOffering = IProduct.ProductOffering || (IProduct.ProductOffering = {}));
    let MerchandisingType;
    (function (MerchandisingType) {
        MerchandisingType["MERCHANDISING_TYPE_UNKNOWN"] = "MERCHANDISING_TYPE_UNKNOWN";
        MerchandisingType["REGULAR"] = "REGULAR";
        MerchandisingType["DISPLAY"] = "DISPLAY";
        MerchandisingType["CUSTOM"] = "CUSTOM";
    })(MerchandisingType = IProduct.MerchandisingType || (IProduct.MerchandisingType = {}));
    /**
     * This enum should be passed in for TranslationOverride#fieldName so that the backend can determine what field
     * on the database entity should be overridden by the relevant translation
     */
    let TranslatableField;
    (function (TranslatableField) {
        TranslatableField["TRANSLATABLE_FIELD_UNKNOWN"] = "TRANSLATABLE_FIELD_UNKNOWN";
        TranslatableField["NAME"] = "NAME";
        TranslatableField["DESCRIPTION"] = "DESCRIPTION";
        TranslatableField["SHORT_DESCRIPTION"] = "SHORT_DESCRIPTION";
    })(TranslatableField = IProduct.TranslatableField || (IProduct.TranslatableField = {}));
    /**
     * The method by which the brand has selected to sell this product
     */
    let SellingMethod;
    (function (SellingMethod) {
        /**
         * See unitMultiplier for details
         */
        SellingMethod["CASE"] = "CASE";
        /**
         * See Type.PREPACK for details
         */
        SellingMethod["PREPACK"] = "PREPACK";
        /**
         * See perStyleMinOrderQuantity for details
         */
        SellingMethod["PER_STYLE_MOQ"] = "PER_STYLE_MOQ";
    })(SellingMethod = IProduct.SellingMethod || (IProduct.SellingMethod = {}));
    let CreatedBy;
    (function (CreatedBy) {
        CreatedBy["CREATED_BY_UNKNOWN"] = "CREATED_BY_UNKNOWN";
        /**
         * Created by Faire employee
         */
        CreatedBy["FAIRE"] = "FAIRE";
        /**
         * Created by a Business Process Optimization
         */
        CreatedBy["BPO"] = "BPO";
        /**
         * Created by the brand
         */
        CreatedBy["BRAND"] = "BRAND";
        /**
         * Created by the retailer (e.g. for a purchase order)
         */
        CreatedBy["RETAILER"] = "RETAILER";
    })(CreatedBy = IProduct.CreatedBy || (IProduct.CreatedBy = {}));
    let CreatedWith;
    (function (CreatedWith) {
        CreatedWith["CREATED_WITH_UNKNOWN"] = "CREATED_WITH_UNKNOWN";
        /**
         * Brand portal single product upload
         * https:cdn.faire.com/fastly/7779ae2cadfa445c751f8284b1bce62a60aecbc5617678d3f8f7e8ef49551a59.png
         */
        CreatedWith["BRAND_PORTAL_SINGLE_PRODUCT"] = "BRAND_PORTAL_SINGLE_PRODUCT";
        /**
         * Brand portal bulk product upload
         * https:cdn.faire.com/fastly/b90b75af2e18c4e756f0acebf21f3228c74c7116c36b13bbb3392ddf3a7cb78e.png
         */
        CreatedWith["BRAND_PORTAL_MULTIPLE_PRODUCTS"] = "BRAND_PORTAL_MULTIPLE_PRODUCTS";
        /**
         * Brand portal shopify import
         * https:cdn.faire.com/fastly/12f8c45fc6d1b97d6c5bfc809507b9f448106cd6b14e80f886a95d3f6c33805b.png
         */
        CreatedWith["BRAND_PORTAL_IMPORT_FROM_SHOPIFY"] = "BRAND_PORTAL_IMPORT_FROM_SHOPIFY";
        /**
         * Imported with admin tool
         * https:cdn.faire.com/fastly/13c94993f530a1673d4e4740f4fa8593c5b49559a77b2ce87733db18986b6f11.png
         */
        CreatedWith["ADMIN_BULK_IMPORT_CSV"] = "ADMIN_BULK_IMPORT_CSV";
        /**
         * Created with a purchase order tool
         * https:cdn.faire.com/fastly/503d24197583bbb993edcfa2d93f5a4377237c9717efd75a02452ecadcc52954.png
         */
        CreatedWith["PURCHASE_ORDER"] = "PURCHASE_ORDER";
        /**
         * Created for a brand invoice
         */
        CreatedWith["BRAND_INVOICE"] = "BRAND_INVOICE";
        /**
         * Created with external API
         */
        CreatedWith["EXTERNAL_API"] = "EXTERNAL_API";
        /**
         * Created with external API
         * https:faire.github.io/external-api-docs/#create-a-product
         * https:faire.github.io/external-api-docs/#create-a-batch-of-products
         */
        CreatedWith["EXTERNAL_API_V2"] = "EXTERNAL_API_V2";
        /**
         * Created for free display attached to a product based collection
         * https:cdn.faire.com/fastly/62e94bd20f3d6706d9e0e4fc819612ff20728f1b3f6c46305d275eb3932c5bdf.jpeg
         */
        CreatedWith["BRAND_PORTAL_FREE_MERCHANDISING_DISPLAY"] = "BRAND_PORTAL_FREE_MERCHANDISING_DISPLAY";
        /**
         * Fields below are for extension to product update sources
         * Created with single product editor in brand portal
         */
        CreatedWith["SINGLE_PRODUCT_EDITOR"] = "SINGLE_PRODUCT_EDITOR";
        /**
         * Created with bulk product editor in brand portal
         */
        CreatedWith["BULK_PRODUCT_EDITOR"] = "BULK_PRODUCT_EDITOR";
        /**
         * Created with bulk product editor in listing quality focused mode
         */
        CreatedWith["LISTING_QUALITY_BULK_EDITOR"] = "LISTING_QUALITY_BULK_EDITOR";
        /**
         * Catch-all for admin actions to update products
         */
        CreatedWith["ADMIN"] = "ADMIN";
        /**
         * Modified through an AI recommendation
         * https:www.notion.so/faire/Product-Title-Description-Recommendations-81d23044b8bf4ef787b79fb3a36f17e9
         */
        CreatedWith["CONTENT_RECOMMENDATION"] = "CONTENT_RECOMMENDATION";
    })(CreatedWith = IProduct.CreatedWith || (IProduct.CreatedWith = {}));
    let IOptionTokenList;
    (function (IOptionTokenList) {
        /**
         * Return an instance of IOptionTokenList with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IOptionTokenList.build = (partial) => (Object.assign({ option_tokens: [], style_variations: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IOptionTokenList = IProduct.IOptionTokenList || (IProduct.IOptionTokenList = {}));
    let PromotedType;
    (function (PromotedType) {
        PromotedType["PROMOTED_TYPE_UNKNOWN"] = "PROMOTED_TYPE_UNKNOWN";
        PromotedType["FAIRE_DIRECT_REWARDS"] = "FAIRE_DIRECT_REWARDS";
        PromotedType["NEW_BRANDS"] = "NEW_BRANDS";
        PromotedType["APPAREL_PERSONALIZED_PRICE_POINT"] = "APPAREL_PERSONALIZED_PRICE_POINT";
        PromotedType["INSIDER"] = "INSIDER";
        PromotedType["ADS"] = "ADS";
        /**
         * Help retailers focus on search results from brands they have previously evaluated for categorically specific searches
         * PRD: https:www.notion.so/faire/Brand-evaluation-for-categorically-narrow-searches-2ac21ed78fc0459d94c12b0864c91c64?pvs=48&qid=
         * @deprecated
         */
        PromotedType["ENGAGED_BRANDS"] = "ENGAGED_BRANDS";
    })(PromotedType = IProduct.PromotedType || (IProduct.PromotedType = {}));
    let BreakDownPrepacksState;
    (function (BreakDownPrepacksState) {
        BreakDownPrepacksState["BREAK_DOWN_PREPACKS_STATE_UNKNOWN"] = "BREAK_DOWN_PREPACKS_STATE_UNKNOWN";
        BreakDownPrepacksState["ON"] = "ON";
        BreakDownPrepacksState["OFF"] = "OFF";
        BreakDownPrepacksState["SMART_RECOGNITION_POSITIVE"] = "SMART_RECOGNITION_POSITIVE";
        BreakDownPrepacksState["SMART_RECOGNITION_NEGATIVE"] = "SMART_RECOGNITION_NEGATIVE";
    })(BreakDownPrepacksState = IProduct.BreakDownPrepacksState || (IProduct.BreakDownPrepacksState = {}));
    /**
     * Return an instance of IProduct with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IProduct.build = (partial) => (Object.assign({ tester_prices: [], options: [], images: [], customizations: [], board_tokens: [], product_information: [], product_information_sections: [], attribute_values: [], translation_overrides: [], style_groups: {}, promoted_by: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IProduct || (IProduct = {}));
